import React, { FC } from 'react'
import { RichTextWrapper } from '../../../../styles/global'

//* utils
import { internalLinkHandler } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import Button from '../../button'
import Typography from '../../typography'

type Props = {
  mediaTextData: any
}

export const TextContainer: FC<Props> = ({ mediaTextData }) => {
  const internalLink = mediaTextData.cta?.internalLink || ''
  const externalUrl = mediaTextData.cta?.externalUrl || ''

  return (
    <div className="MediaText__Text-Container">
      {mediaTextData.headline && (
        <Typography type="header3" className="MediaText__Heading">
          {formatInlineCode(mediaTextData.headline)}
        </Typography>
      )}

      {mediaTextData?.subtitle && (
        <Typography type="header5" className="MediaText__subHeading">
          {formatInlineCode(mediaTextData.subtitle)}
        </Typography>
      )}

      {mediaTextData.body && (
        <RichTextWrapper $type="body" className="MediaText__Body">
          {renderRichText(mediaTextData.body)}
        </RichTextWrapper>
      )}

      {mediaTextData.cta && (
        <Button
          icon={true}
          href={internalLink ? internalLinkHandler(internalLink) : externalUrl}
          text={mediaTextData.cta?.text}
          type={
            mediaTextData?.useCase === 'Events' && mediaTextData?.theme === 'Orange'
              ? 'tertiary'
              : 'text-link'
          }
          size="small"
          theme={
            mediaTextData.theme === 'Dark' || mediaTextData?.theme === 'Orange' ? 'dark' : 'light'
          }
        />
      )}
    </div>
  )
}
